<template>
  <div class="nx-list-page">
    <avue-crud
      ref="crud"
      v-model="form"
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      :search.sync="query"
      :defaults.sync="defaults"
      @search-change="searchChange"
      @search-reset="searchReset"
      @refresh-change="refreshChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @selection-change="selectionChange"
      @on-load="onLoad"
    >
      <template slot="menuLeft">
        <el-button type="primary" size="small" plain icon="el-icon-back" @click="goBack">
          返回
        </el-button>
      </template>
      <template slot-scope="{ row }" slot="signatureFileUrl">
        <el-button
          v-if="row.signatureFileUrl"
          type="text"
          size="small"
          icon="el-icon-picture-outline"
          @click="openSignature(row.signatureFileUrl)"
        >
          查看
        </el-button>
        <span v-else>-</span>
      </template>
      <template #menu="{ row }">
        <el-button type="text" size="small" icon="el-icon-view" @click="handleSignDetail(row)">
          详情
        </el-button>
      </template>
    </avue-crud>

    <el-dialog title="阅读记录详情" :visible.sync="signDetailVisible" width="680px" append-to-body>
      <el-descriptions v-if="signDetail" :column="2" border size="small">
        <el-descriptions-item label="司机姓名">{{ signDetail.driverName }}</el-descriptions-item>
        <el-descriptions-item label="手机号">{{ signDetail.driverPhone }}</el-descriptions-item>
        <el-descriptions-item label="身份证号">{{ signDetail.driverIdentityCard }}</el-descriptions-item>
        <el-descriptions-item label="标准版本">{{ signDetail.standardVersion }}</el-descriptions-item>
        <el-descriptions-item label="签名时间">{{ signDetail.signTime }}</el-descriptions-item>
        <el-descriptions-item label="签名来源">{{ formatSignSource(signDetail.signSource) }}</el-descriptions-item>
      </el-descriptions>
      <div v-if="signDetail && signDetail.signatureFileUrl" class="signature-preview">
        <el-image
          :src="signDetail.signatureFileUrl"
          :preview-src-list="[signDetail.signatureFileUrl]"
          fit="contain"
        />
      </div>
      <span slot="footer">
        <el-button @click="signDetailVisible = false">关闭</el-button>
      </span>
    </el-dialog>

    <el-dialog title="签名图片" :visible.sync="signaturePreviewVisible" width="720px" append-to-body>
      <div class="signature-image-preview">
        <el-image
          v-if="signaturePreviewUrl"
          :src="signaturePreviewUrl"
          :preview-src-list="[signaturePreviewUrl]"
          fit="contain"
        />
        <div v-else class="signature-empty">暂无签名图片</div>
      </div>
      <span slot="footer">
        <el-button @click="signaturePreviewVisible = false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getSignList, getSignDetail } from "./api";
import crudMixins from "@/mixins/crud-mixins";
import { searchTimeConfig } from "@/basic-common/util/common";

export default {
  name: "DriverEntryNoticeReadRecord",
  mixins: [crudMixins],
  data() {
    return {
      apiConfig: {},
      signDetailVisible: false,
      signDetail: null,
      signaturePreviewVisible: false,
      signaturePreviewUrl: "",
      option: {
        ...this.$store.state.publicOption,
        addBtn: false,
        editBtn: false,
        delBtn: false,
        viewBtn: false,
        menuWidth: 100,
        column: [
          { label: "司机姓名", prop: "driverName", search: true, overHidden: true },
          { label: "手机号", prop: "driverPhone", search: true, overHidden: true },
          { label: "身份证号", prop: "driverIdentityCard", search: true, overHidden: true },
          { label: "标准版本", prop: "standardVersion", search: true, overHidden: true },
          {
            label: "签名时间",
            prop: "signTime",
            type: "datetime",
            format: "yyyy-MM-dd HH:mm:ss",
            valueFormat: "yyyy-MM-dd HH:mm:ss",
          },
          { label: "签名文件", prop: "signatureFileUrl", slot: true, overHidden: true },
          {
            label: "签名来源",
            prop: "signSource",
            type: "select",
            dicData: [
              { label: "小程序", value: "miniapp" },
              { label: "后台", value: "admin" },
            ],
          },
          {
            ...searchTimeConfig,
            label: "签名时间",
            paramsKey: ["signStartTime", "signEndTime"],
          },
        ],
      },
    };
  },
  created() {
    this.apiConfig = {
      getList: getSignList,
    };
  },
  methods: {
    goBack() {
      this.$router.push("/basic-info/driver-entry-standard/index");
    },
    handleSignDetail(row) {
      getSignDetail(row.id).then((res) => {
        this.signDetail = res.data.data || res.data;
        this.signDetailVisible = true;
      });
    },
    openSignature(url) {
      this.signaturePreviewUrl = url || "";
      this.signaturePreviewVisible = true;
    },
    formatSignSource(value) {
      if (value === "miniapp") return "小程序";
      if (value === "admin") return "后台";
      return value || "-";
    },
  },
};
</script>

<style scoped lang="scss">
.signature-preview,
.signature-image-preview {
  margin-top: 16px;
  text-align: center;

  .el-image {
    width: 100%;
    max-height: 320px;
    border: 1px solid #ebeef5;
    border-radius: 4px;
    background: #fafafa;
  }
}

.signature-empty {
  padding: 48px 0;
  color: #909399;
  font-size: 14px;
}
</style>
